import React, {useState, useEffect, useRef} from 'react';
import { Table, Tag, Tooltip } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';
import { useDidiSection } from "hooks/actives/didi-section";
import { DEFAULT_PAGE_INFO } from "consts";
import emiter, { _EVENTS } from "../../../../events";
import './index.css'
import CarProdName from "components/product-price/car-model-price/table/car-prod-name";
import ShangjiafenColumn from "./shangjiafen";
import CancelTemplateColumn from "./cancel-template-column";
import ServiceTemplateColumn from "./service-template-column";
import ValueAddServiceTemplateColumn from "./value-add-service-template-column";

interface IComponentProps {
  enums?: any;
  permission?: any;
}
interface IValueAddedPriceTableDataType {
    key?: any;
    id?: any;
    name?: any;
    state?: any;
    createDate?: any;
    [key: string]: any;
};
const SPTable: React.FC<IComponentProps> = (props) => {
  const { enums, permission } = props;
  const [allResData, setAllResData] = useState<any>({});

  const columns: TableProps<IValueAddedPriceTableDataType>['columns'] = [
    // { title: '供应商名称', dataIndex: 'supplier_name', key: 'supplier_name' },
    { title: '车型商品名称', width: 150, dataIndex: 'name', render: (_, record) => (<CarProdName data={record} />) },
    { title: '车型等级', width: 100, dataIndex: 'veh_group_code', key: 'veh_group_code' },
    { title: '门店名称', width: 150, dataIndex: 'store_name', key: 'store_name' },
    { title: (<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <div>商家分</div>
        <Tooltip title={ `商家分 ≥ ${allResData?.selected_standard?.store_srv_score}分` }>
          <img style={{width: '16px', height: '16px', marginLeft: '4px'}}
               src="https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/yiwen.png" alt=""/>
        </Tooltip>
      </div>), width: 90, dataIndex: 'store_srv_score', render: (_, record) => (<ShangjiafenColumn data={record}/>)
    },
    {
      title: '取消规则',
      width: 150, dataIndex: 'cancel_rule_name',  render: (_, record) => (<CancelTemplateColumn data={record} />) },
    { title: '里程限制', width: 150, dataIndex: 'serve_rule_name', render: (_, record) => (<ServiceTemplateColumn data={record} />) },
    { title:  (<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <div>优享保障及价格</div>
        <Tooltip title={( <>
          <div>1、车型商品必须关联优享保障；</div>
          <div>
            2、不同等级车型的优享保障价格标准如下：
          </div>
          {
            (allResData?.selected_standard?.insurance_rule_vip?.price || []).map((item: any) => {
              return <div>
                {item.car_group} ≤ {item.price / 100} 元
              </div>
            })
          }

        </>)}>
          <img style={{width: '16px', height: '16px', marginLeft: '4px'}}
               src="https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/yiwen.png" alt=""/>
        </Tooltip>
      </div>), width: 200, dataIndex: 'insurance_rule_vip_name', render: (_, record) => (<ValueAddServiceTemplateColumn data={record} />) },
    { title: '是否符合条件', width: 90, dataIndex: 'ok', key: 'name', render: (_, record) => (
        record.ok ? <Tag color="success">符合</Tag> : <Tag color="error">不符合</Tag>
      ) },
  ];

  const [data, setData] = useState<any>([]);

  const [totalCount, setTotalCount] = useState(0);
  const [currentPageData, setCurrentPageData] = useState<any>();
  const dataRef = useRef({});

  const { search, tablePagination } = useDidiSection();

  const load = (params?: any) => {
      params = Object.assign({...DEFAULT_PAGE_INFO}, {...dataRef.current}, params);
      search(params).then((data: any) => {
          const res = data?.data
          setAllResData(res || {})
          setData(res?.list || []);
          setTotalCount(res?.total);
          dataRef.current = params
          setCurrentPageData({page: data.page || 1, page_size: data.page_size || 10});
      })
  };

  // TODO: 清空再搜索，翻页有问题
  const onPagination = (pagination: TablePaginationConfig) => {
    tablePagination(Object.assign(dataRef.current, {
      page: pagination.current,
      page_size: pagination.pageSize
    }))
  };


  useEffect(() => {
    emiter.on(_EVENTS.ACTIVES.DIDI_SECTION.SEARCH, load);
    return () => {
        emiter.removeAllListeners(_EVENTS.ACTIVES.DIDI_SECTION.SEARCH)
    }
  }, []);

  return <>
    <div className='tab-desc'>
      <div className='allNum'>
        <span>总商品数：</span>
        <span> {allResData?.total} </span>
      </div>
      <div className='common-left meet-the-conditions'>
        <span>符合条件商品数：</span>
        <span> {allResData?.ok_cnt}  </span>
      </div>
      <div className='common-left disqualification'>
        <span>不符合条件商品数：</span>
        <span> {allResData?.not_ok_cnt}  </span>
      </div>
    </div>
    <Table
      size='middle'
      scroll={{x: '100%'}}
      columns={columns}
      dataSource={data}
      bordered={true}
      pagination={{ total:totalCount, showSizeChanger: true, showQuickJumper: true,showTotal:total => `共 ${total} 条数据`,current:currentPageData?.page,pageSize:currentPageData?.page_size }}
      rowKey={cols => cols.id}
      onChange={onPagination}
    />
  </>
};

export default SPTable;

